const normalObj = {sphericalEnvMap: '', roughness: 0.8, metalness: 0.4};
const shineObj = {sphericalEnvMap: '#envmapImg', roughness: 0.2, metalness: 0.6};

/**
 * Rank color.
 */
AFRAME.registerComponent('victory-rank', {
  schema: {
    isVictory: {default: false},
    rank: {type: 'string'}
  },

  update: function (oldData) {
    const el = this.el;
    const rank = this.data.rank;

    if (oldData.isVictory && !this.data.isVictory) {
      this.el.object3D.scale.set(0.001, 0.001, 0.001);
    }

    if (!rank) { return; }

    el.setAttribute('text-geometry', 'value', rank);
    switch (rank[0]) {
      case 'S': {
        el.setAttribute('material', Object.assign({color: '#F0e077'}, shineObj));
        break;
      }
      case 'A': {
        el.setAttribute('material', Object.assign({color: '#6FF9EA'}, shineObj));
        break;
      }
      case 'B': {
        el.setAttribute('material', Object.assign({color: '#F8d'}, shineObj));
        break;
      }
      case 'C': {
        el.setAttribute('material', Object.assign({color: '#F971C3'}, normalObj));
        break;
      }
      case 'D': {
        el.setAttribute('material', Object.assign({color: '#1E6269'}, normalObj));
        break;
      }
      case 'F': {
        el.setAttribute('material', Object.assign({color: '#e3170a'}, normalObj));
        break;
      }
    }
  }
});
if (module.hot && window.AFRAME) {
  const componentNames = ['victory-rank',];

  const shaderNames = [];

  const systemNames = [];

  // Clean up from application when module is unloaded.
  module.hot.dispose(data => {
    let els;
    data.needsReplace = true;

    componentNames.forEach(component => {
      // Unregister.
      delete AFRAME.components[component];
      const els = AFRAME.scenes[0].querySelectorAll(`[${component}]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        els[i].setAttribute(`data-__hot-${component}`,
                            JSON.stringify(els[i].getDOMAttribute(component)));
        // Detach component.
        els[i].removeAttribute(component);
      }
    });

    shaderNames.forEach(shader => {
      // Unregister.
      delete AFRAME.shaders[shader];
      const els = AFRAME.scenes[0].querySelectorAll(`[material]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        if (els[i].getAttribute('material').shader !== shader) { continue; }
        els[i].setAttribute('data-__hot-material', JSON.stringify(
          els[i].getDOMAttribute('material')));
        // Detach material.
        els[i].removeAttribute('material');
      }
    });

    systemNames.forEach(system=> {
      delete AFRAME.systems[system];
      delete AFRAME.scenes[0].systems[system];
    });
  });

  if (module.hot.data && module.hot.data.needsReplace) {
    // Apply component back to entities.
    componentNames.forEach(componentName => {
      const dataAttrName = `data-__hot-${componentName}`;
      const els = document.querySelectorAll(`[${dataAttrName}]`);
      for (let i = 0; i < els.length; i++) {
        els[i].setAttribute(componentName, JSON.parse(els[i].getAttribute(dataAttrName)), true);
        els[i].removeAttribute(dataAttrName);
      }
    });

    // Apply materials back.
    const dataAttrName = 'data-__hot-material';
    const els = document.querySelectorAll(`[${dataAttrName}]`);
    for (let i = 0; i < els.length; i++) {
      els[i].setAttribute('material', JSON.parse(els[i].getAttribute(dataAttrName)), true);
      els[i].removeAttribute(dataAttrName);
    }
  }

  module.hot.accept();
}
